import React, { useState } from 'react'

import { useQuery, useMutation } from '@apollo/client'
import { GET_CITATION_NOTES } from '@chegg-wt/core/queries/FormattedCitations'
import {
  GetCitationNotesVariables,
  GetCitationNotes,
  GetCitationNotes_comments,
} from '@chegg-wt/core/queries/GetCitationNotes'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import {
  CreateCitationNote,
  CreateCitationNoteVariables,
} from '@chegg-wt/core/queries/CreateCitationNote'
import { CREATE_CITATION_NOTE } from '@chegg-wt/core/queries/Citations'
import { format, parseISO } from 'date-fns'
import * as Styled from './styled'

interface Props {
  citationId: string
  projectId: string
  toggleNotes: (showNotes: boolean) => void
}

export const NOTE_HIDE_TEST_ID = 'note-hide'
export const NOTE_INPUT_TEST_ID = 'note-input'
export const NOTE_POST_BTN_TEST_ID = 'note-post-btn'

const Notes: React.FC<Props> = ({ citationId, projectId, toggleNotes }) => {
  const [value, onInputChange] = useState('')

  const { data: notesData, loading: isNotesLoading, refetch: refetchNotes } = useQuery<
    GetCitationNotes,
    GetCitationNotesVariables
  >(GET_CITATION_NOTES, {
    variables: {
      projectId,
      citationId,
    },
    ssr: false,
    fetchPolicy: 'cache-and-network',
  })

  const [createCitationNote] = useMutation<
    CreateCitationNote,
    CreateCitationNoteVariables
  >(CREATE_CITATION_NOTE)

  const handleAddNote = () => {
    onInputChange('')
    createCitationNote({
      variables: {
        citationId,
        projectId,
        text: value,
      },
    }).then(() =>
      refetchNotes({
        projectId,
        citationId,
      })
    )
  }

  return (
    <Styled.Container>
      <Styled.HeaderContainer>
        <Styled.Header>Notes</Styled.Header>
        <Styled.Hide
          role="button"
          data-test={NOTE_HIDE_TEST_ID}
          onClick={() => toggleNotes(false)}
        >
          Hide
        </Styled.Hide>
      </Styled.HeaderContainer>
      <Styled.NoteInput
        placeholder="Enter your note here."
        value={value}
        data-test={NOTE_INPUT_TEST_ID}
        onChange={onInputChange}
        inputId="note"
        labelText="note"
        visuallyHideLabel
      />
      <Styled.PostButton
        onClick={handleAddNote}
        disabled={!value.length}
        data-test={NOTE_POST_BTN_TEST_ID}
      >
        Post
      </Styled.PostButton>
      {isNotesLoading && <LoadingDots message="Loading citation's notes" />}
      {notesData?.comments &&
        notesData?.comments.map((note: GetCitationNotes_comments) => (
          <React.Fragment key={note.createdAt}>
            <Styled.Notenotenote>
              <Styled.NoteName>{note.fullName}</Styled.NoteName>
              <Styled.NoteDate>
                {format(parseISO(note.createdAt), 'MM/dd/yyyy [at] h:mma')}
              </Styled.NoteDate>
            </Styled.Notenotenote>
            <Styled.NoteText>{note.text}</Styled.NoteText>
          </React.Fragment>
        ))}
    </Styled.Container>
  )
}

export default Notes
